<ion-content class="modal-options ion-padding">
  <div class="modal-form-container">
    <div class="content-top">
      <h3 class="title font-heavitas">{{ product.name }}</h3>
      @if (shouldShowReference()) {
      <p class="reference">
        {{ product.reference }}
      </p>
      }
      <p class="price">{{ product.price | arsCurrency }}</p>
      <!-- Alert -->
      <div class="pb-8">
        @if (!isMembership) {
        <app-info-alert
          [message]="'generate-code-modal.info' | translate"
          type="warning"
        />
        } @if (isMembership) {
        <app-info-alert
          [message]="'generate-code-modal.info-membership' | translate"
          type="warning"
        />
        }
      </div>
      <!-- Form -->
      <div class="message-container">
        <app-quantity-selector
          [value]="quantity()"
          (valueChange)="quantity.set($event)"
          [min]="1"
          [max]="limitQuantity()"
          [label]="'generate-code-modal.quantity' | translate"
        />
      </div>
    </div>
    <!-- Buttons -->
    <div class="buttons-bottom">
      <app-main-button
        [label]="'generate-code-modal.generate'"
        [loadingLabel]="'generate-code-modal.generating'"
        (clicked)="generateCode()"
        [disabled]="isLoading()"
        [loading]="isLoading()"
      />
    </div>
  </div>
</ion-content>
